import React from 'react';
import { MessageInputContextProvider, useMessageInputContext } from 'stream-chat-react';

export const CustomTriggerProvider = ({ children }) => {
  const currentContextValue = useMessageInputContext();
  return (<MessageInputContextProvider value={{...currentContextValue, autocompleteTriggers: {}}}>{children}</MessageInputContextProvider>);
};